import client from './api-client';

export const postMetricasRecupero = async (body) => {
    try {
        const response = await client.post('dashboard/metricas-recupero', body);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
}
